import { HttpErrorResponse } from '@angular/common/http';
import { ICurrencyExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { EntityState } from '@ngrx/entity';

export interface ICurrencyState extends EntityState<ICurrencyExtendedDTO> {
    activeCurrency?: ICurrencyExtendedDTO;
    error?: HttpErrorResponse;
}
